'use strict';

exports.__esModule = true;
exports.default = toApiExternalType;

var _utils = require('./utils');

function toApiExternalType(actionType) {
  var asyncTypes = (0, _utils.toAsyncTypes)(actionType);
  return {
    REQUEST: asyncTypes[0],
    RESPONSE: asyncTypes[1]
  };
}